import { render, staticRenderFns } from "./CMСurssSidebar.vue?vue&type=template&id=125266b2&scoped=true&lang=pug"
import script from "./CMСurssSidebar.vue?vue&type=script&lang=js"
export * from "./CMСurssSidebar.vue?vue&type=script&lang=js"
import style0 from "./CMСurssSidebar.vue?vue&type=style&index=0&id=125266b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125266b2",
  null
  
)

export default component.exports